/**
 * Safe Logger [FE.8.1]
 * Enforces PHI governance by restricting what is written to the console.
 */
class SafeLogger {
    private isDevelopment = import.meta.env.DEV

    /**
     * Logs an event with strictly approved metadata only.
     * NO payloads, NO PHI, NO free text.
     */
    logEvent(eventName: string, metadata: {
        status?: number
        route?: string
        trace_id?: string
        request_id?: string
        error_code?: string
    }) {
        if (!this.isDevelopment) return

        console.log(`[EVENT: ${eventName}]`, JSON.stringify(metadata))
    }

    /**
     * Logs a navigation event.
     */
    logRoute(from: string, to: string) {
        this.logEvent('navigation', { route: to })
    }

    /**
     * Safe error logging - strictly codes and IDs.
     */
    logError(code: string, trace_id: string) {
        console.error(`[ERROR: ${code}]`, { trace_id })
    }
}

export const safeLogger = new SafeLogger()
